import React from "react";
import { Shop } from "../../../types/shop";
import { ConfirmationDialog } from "../../../components/common/ConfirmationDialog/ConfirmationDialog";

interface DeleteConfirmationDialogProps {
  open: boolean;
  shop: Shop | null;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  shop,
  onClose,
  onConfirm,
  isLoading,
}) => {
  return (
    <ConfirmationDialog
      open={open}
      title="Delete Shop"
      message={`Are you sure you want to delete the shop "${shop?.name}"? This action cannot be undone.`}
      confirmLabel="Delete"
      confirmColor="error"
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
    />
  );
};

export default DeleteConfirmationDialog;
